export const publicLayout = {
  page: 'public-page',
  container: 'public-container',
  section: 'public-section',
  sectionMuted: 'public-section-muted',
  sectionSurface: 'public-section-surface',
  sectionAccent: 'public-section-accent'
};

export const publicUi = {
  card: 'public-card',
  cardInteractive: 'public-card-interactive',
  pill: 'public-pill',
  buttonPrimary: 'public-btn-primary',
  buttonSecondary: 'public-btn-secondary',
  heroShell: 'public-hero-shell',
  heroGrid: 'public-grid-hero',
  heroContent: 'public-hero-content',
  heroVisual: 'public-hero-visual'
};

export const publicMotion = {
  sectionReveal: {
    initial: { opacity: 0, y: 18 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.55, ease: 'easeOut' },
    viewport: { once: true, amount: 0.2 }
  },
  heroEnterLeft: {
    initial: { opacity: 0, x: -30 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.7, ease: 'easeOut' }
  },
  heroEnterRight: {
    initial: { opacity: 0, x: 30 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.7, delay: 0.1, ease: 'easeOut' }
  },
  staggerChildren: (index = 0, step = 0.08) => ({
    initial: { opacity: 0, y: 16 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.45, delay: index * step, ease: 'easeOut' },
    viewport: { once: true, amount: 0.2 }
  })
};

export const publicResponsive = {
  mobile: 'default < 640px',
  tablet: 'sm >= 640px, md >= 768px',
  desktop: 'lg >= 1024px, xl >= 1280px',
  containerMax: 'max-w-7xl',
  baseSpacingY: 'py-20',
  baseSpacingX: 'px-4 sm:px-6 lg:px-8'
};
